import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateStatsApplications = {
  statsApplications: { data: null, loading: false, error: null },
};

export const statsApplications = createAsyncThunk('user/statsApplications', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/vacancies/applications/categories`, {
      params: { vacancy_id: data },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerStatsApplications = {
  [statsApplications.pending]: (state) => {
    // state.statsApplications.data = null;
    state.statsApplications.loading = true;
    state.statsApplications.error = null;
  },
  [statsApplications.fulfilled]: (state, action) => {
    state.statsApplications.loading = false;
    state.statsApplications.data = action.payload;
    state.statsApplications.error = null;
  },
  [statsApplications.rejected]: (state, action) => {
    state.statsApplications.loading = false;
    state.statsApplications.error = action.payload;
  },
};
